export enum ReportType {
  Anchor = 'Anchor',
  Sea = 'Sea',
  Departure = 'Departure',
  Port = 'Port',
  Maneuvering = 'Maneuvering',
  SeaArrival = 'Sea (Arrival)',
  Drifting = 'Drifting',
}
